module.exports = __webpack_public_path__ + "static/media/great-job.98623516.png";